import * as PopoverPrimitive from "@radix-ui/react-popover"
import * as React from "react"

import { useDialogContext } from "@/hooks/use-dialog-context"
import { cn } from "@/utils/styles.helpers"

function Popover({
	modal,
	...props
}: React.ComponentProps<typeof PopoverPrimitive.Root>) {
	const { inDialog } = useDialogContext()
	const modalBehavior = modal ?? inDialog

	return (
		<PopoverPrimitive.Root
			data-slot="popover"
			modal={modalBehavior}
			{...props}
		/>
	)
}

function PopoverTrigger({
	...props
}: React.ComponentProps<typeof PopoverPrimitive.Trigger>) {
	return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />
}

function PopoverContent({
	className,
	align = "center",
	sideOffset = 4,
	...props
}: React.ComponentProps<typeof PopoverPrimitive.Content>) {
	const { inDialog } = useDialogContext()

	return (
		<PopoverPrimitive.Portal>
			<PopoverPrimitive.Content
				data-slot="popover-content"
				align={align}
				sideOffset={sideOffset}
				className={cn(
					"bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 w-72 origin-(--radix-popover-content-transform-origin) rounded-md border p-4 shadow-lg outline-hidden",
					inDialog ? "z-[60]" : "z-50",
					className,
				)}
				{...props}
			/>
		</PopoverPrimitive.Portal>
	)
}

function PopoverAnchor({
	...props
}: React.ComponentProps<typeof PopoverPrimitive.Anchor>) {
	return <PopoverPrimitive.Anchor data-slot="popover-anchor" {...props} />
}

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor }
